import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import Button from '@Components/Common/Button';

import TX from '@Components/Common/Text';
import NonCompletionNotice from '@Components/Common/NonCompletionNotice';

import { isDuplicateTitle } from '@Utils/Item';

import { ReactComponent as AddSVG } from '@Assets/Svgs/ic_add.svg';
import { ReactComponent as EditSVG } from '@Assets/Svgs/ic_edit.svg';

const Bottom = ({
  isUsingAchievementChip,
  isUsingEditMode,
  achievement,
  handleEditModeButtonClick,
  handleAddAchievementButtonClick,
}) => {
  const getIsDuplicateTitle = () => {
    const allTitleList = achievement.map(({ title }) => title).filter(title => title);

    return isDuplicateTitle(allTitleList);
  };

  const isShowNonCompletionNotice = getIsDuplicateTitle();

  return (
    <BottomContainer>
      {isUsingAchievementChip ? (
        <Wrapper>
          {isUsingEditMode ? (
            <ButtonContainer>
              <Button isTextOnly={false} disabled={isShowNonCompletionNotice} onClick={handleEditModeButtonClick}>
                <IconWrapper>
                  <EditIcon fill="#FFFFFF" />
                </IconWrapper>

                <ButtonText isWhite>편집 완료</ButtonText>
              </Button>

              <Button isTextOnly={false} backgroundColor="#F2F2F3" onClick={handleAddAchievementButtonClick}>
                <IconWrapper>
                  <AddIcon />
                </IconWrapper>

                <ButtonText>업적 추가</ButtonText>
              </Button>
            </ButtonContainer>
          ) : (
            <Button isTextOnly={false} backgroundColor="transparent" onClick={handleEditModeButtonClick}>
              <IconWrapper>
                <EditIcon />
              </IconWrapper>

              <ButtonText>편집</ButtonText>
            </Button>
          )}
        </Wrapper>
      ) : (
        <Button isTextOnly={false} disabled={isShowNonCompletionNotice} onClick={handleAddAchievementButtonClick}>
          <IconWrapper>
            <AddIcon stroke="#FFFFFF" />
          </IconWrapper>

          <ButtonText isWhite>업적 추가</ButtonText>
        </Button>
      )}

      {isShowNonCompletionNotice && <NonCompletionNotice text="같은 이름의 업적이 있습니다." />}
    </BottomContainer>
  );
};

Bottom.propTypes = {
  isUsingAchievementChip: PropTypes.bool.isRequired,
  isUsingEditMode: PropTypes.bool.isRequired,
  achievement: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleEditModeButtonClick: PropTypes.func.isRequired,
  handleAddAchievementButtonClick: PropTypes.func.isRequired,
};

const IconCSS = css`
  width: 16px;
  height: 16px;
`;

const FlexAlignCenterDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div``;

const BottomContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;

  width: 100%;
  height: 60px;

  padding: 8px 20px 20px 20px;

  position: absolute;
  bottom: 0;
  border-radius: 0px 0px 14px 14px;

  background-color: ${({ theme }) => theme.colors.white};
`;

const ButtonContainer = styled(FlexAlignCenterDiv)`
  gap: 0px 4px;
`;

const IconWrapper = styled(FlexAlignCenterDiv)`
  ${IconCSS}

  margin-right: 8px;
`;

const AddIcon = styled(AddSVG)`
  ${IconCSS}

  stroke: ${({ stroke, theme }) => stroke || theme.colors.ui_on_1};
`;

const EditIcon = styled(EditSVG)`
  ${IconCSS}

  fill: ${({ fill, theme }) => fill || theme.colors.ui_on_3}
`;

const ButtonText = styled(TX.FootnoteM)`
  color: ${({ isWhite, theme }) => (isWhite ? theme.colors.white : theme.colors.ui_on_1)};
`;

export default Bottom;
